var map = {
	"./horizontal/en/color-black.svg": 567,
	"./horizontal/en/color-white.svg": 568,
	"./horizontal/en/mono-black.svg": 569,
	"./horizontal/uk/color-black.svg": 570,
	"./horizontal/uk/color-white.svg": 571,
	"./horizontal/uk/mono-black.svg": 572,
	"./icon/default/lun_icon.svg": 573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 566;